export enum CognitoStateType {
  LOGIN = 'LOGIN',
  COMPLETE_PASSWORD = 'COMPLETE_PASSWORD',
  FORGOT_PASSWORD = 'FORGOT_PASSWORD',
  RESET_PASSWORD = 'RESET_PASSWORD',
  RESET_PASSWORD_COMPLETE = 'RESET_PASSWORD_COMPLETE',
}
